export default {
    comingSoonTips: 'Rights issue feature coming soon, stay tuned.',
    HKStockMarket: 'HK Stock Market',
    historyList: 'History',
    doNotHoldStocks: 'You do not hold stocks for rights issue',
    applyStocksTips: 'You hold stocks for rights issue, please decide before the deadline; no action means waiver.',
    requested: 'Requested',
    rightIssueCode: 'Rights Issue Code',
    stockPrice: 'Rights Issue Price',
    availableStockNumbers: 'Available Shares',
    availableStockNumbersTips: 'Available shares = issued rights + bought rights - sold/frozen rights',
    tenderOfferAvailableQuantity: 'Available Quantity',
    stock: 'Shares',
    stockDeadline: 'Rights Issue Deadline:',
    warmTips: 'Tips:',
    warmTips1:
        'Subscription amount will be frozen upon application and deducted after the deadline. Cancellation is supported before deduction (time as per page).',
    warmTips2: 'Fees include exchange fee (HKD 0.8 per lot), Fosun Securities fee (HKD 50.00), rounded up to nearest lot.',
    warmTips3: 'Due to processing, shares will be credited 1-2 business days after distribution, actual time may vary.',
    warmTips4: 'HK Central Clearing (Agent) will allocate additional shares as per rules or their discretion.',
    listed: 'Listed',
    lastTrade: 'Last Trade',
    rightsIssueDeadline: 'Rights Issue Deadline',
    stockDistribution: 'Stock Distribution',
    rightsIssueInfo: 'Rights Issue Info',
    stockName: 'Stock Name',
    additionalRightsIssues: 'Additional Rights Issue',
    opening: 'Open',
    notOpen: 'Closed',
    rightsIssueTransactions: 'Rights Issue Transactions',
    Tradable: 'Tradable',
    notTradable: 'Non-Tradable',
    equityInfo: 'Equity Info',
    rightsIssuePurchased: 'Rights Issue Bought',
    rightsIssueSold: 'Rights Issue Sold/Frozen',
    rightsIssueSoldTips: 'When tradable, rights sold or pending sale.',
    additionalSharesAvailable: 'Additional Shares Available',
    additionalSharesAvailableTips: 'When open, max shares available is "Unlimited"; otherwise 0.',
    unlimitedQuantity: 'Unlimited',
    chooseIssueShares: 'Choose to Issue Shares',
    applicationsNumber: 'Application Quantity (Shares)',
    applicationsNumber1: 'Application Quantity',
    applicationsNumber2: 'Rights Issue Application Quantity',
    upperLimit: 'Upper Limit',
    additionalApplicationsNumber: 'Additional Application Quantity (Shares)',
    additionalApplicationsNumber1: 'Additional Application Quantity',
    additionalApplicationsNumber2: 'Additional Rights Issue Application Quantity',
    availableCash: 'Available Cash',
    estimatedFreezeAmount: 'Estimated Freeze Amount (Incl. Fees)',
    rightsIssueOptions: 'Rights Issue Options',
    rightsIssueApplications: 'Pending Rights Issue Applications',
    rightsIssueStatus: 'Rights Issue Status',
    rightsIssueWaiver: 'Waive Rights Issue',
    rightsIssueApply: 'Apply for Rights Issue',
    rightsIssueVoluntaryWaiver: 'Auto Waive Rights Issue',
    applicationCanceled: 'Application Canceled',
    applyImmediately: 'Apply Now',
    applicationTips1: 'Please enter application quantity',
    applicationTips2: 'Application quantity exceeds limit!',
    applicationTips3: 'Insufficient available cash!',
    applicationTips4: 'Insufficient available shares!',
    confirmApplicationTips: 'Confirm to cancel application?',
    confirm: 'Confirm',
    undoSucceeded: 'Canceled Successfully',
    applicationConfirm: 'Application Confirmation',
    applicationConfirmTips: 'Confirm to waive rights issue?',
    applicationSuccessful: 'Application Successful',
    understood: 'Understood',
    wrongPassword: 'Wrong Password',
    processing: 'Processing',
    applicationAmount: 'Application Amount (Incl. Fees)',
    actualDistributedNumber: 'Actual Distributed Shares',
    stockDeliveryTime: 'Stock Delivery Time',
    requestFailed: 'Request Failed',
    noMore: 'No More',
    noStockTips: 'No rights issue application records',
    loginFailedTips: 'Login expired, please re-login',
    stystemBusyTips: 'Network timeout, please retry later. Contact customer service for help.',
    optionsBonusPageTitle: 'Options Trading Bonus Event',
    eventRule: 'Rules',
    goTrade: 'Trade Now',
    optionsBonusShareDesc: 'Limited-time options trading event with rewards up to 100,000 HKD.',
    tenderOffer: 'Tender Offer',
    offerType: 'Offer Type',
    unconditionalOffer: 'Unconditional Offer',
    tenderOfferPrice: 'Offer Price',
    tenderOfferDeadline: 'Tender Offer Deadline:',
    pendingApply: 'Pending',
    noTenderOfferStocks: 'You do not hold stocks for tender offer',
    tenderOfferDetail: 'Tender Offer Details',
    startApplication: 'Start Application',
    applicationDeadline: 'Application Deadline',
    lastTradingDay: 'Last Trading Day',
    cashArrival: 'Cash Arrival',
    pleaseFollowCashFlow: 'Please follow the cash flow',
    conditionalOffer: 'Conditional Tender Offer',
    chooseTenderOffer: 'Choose whether to accept the tender offer',
    acceptTenderOffer: 'Accept Tender Offer',
    waiveTenderOffer: 'Waive Tender Offer',
    transactionAmountEstimate: 'Transaction Amount (estimated if fully executed)',
    conditionalOfferDisclaimer: '*If conditional, offeror does not guarantee full acceptance.',
    handlingFee: 'Handling Fee (estimated if fully executed)',
    feeStandard: 'Fee Standard',
    disclaimer: 'Disclaimer',
    tenderOfferDetailWarmTips1: 'Accepted shares will be frozen immediately after you submit the application and deducted after the tender offer deadline.',
    tenderOfferDetailWarmTips2: 'You may cancel before the tender offer deadline.',
    tenderOfferDetailWarmTips3: 'Handling fee: Deducted from credited funds. Charged at 0.25% of transaction amount (minimum HKD), plus exchange fees per applicable standards. See ',
    tenderOfferDetailWarmTips4: 'Please read ',
    tenderOfferWaiveConfirm: 'Confirm to waive tender offer?',
    tenderOfferSelection: 'Tender Offer Selection',
    tenderOfferStatusLabel: 'Tender Offer Status',
    tenderOfferStatusWaived: 'Waived',
    tenderOfferType: 'Tender Offer Type',
    noTenderOfferHistoryTips: 'No tender offer history',
    tenderOfferHistoryStatusAccepted: 'Accepted',
    tenderOfferHistoryStatusWaived: 'Waived',
    tenderOfferHistoryStatusPending: 'Pending',
    tenderOfferHistoryStatusDeductSuccess: 'Deduction Successful',
    tenderOfferHistoryStatusDeductFailed: 'Deduction Failed',
    tenderOfferHistoryStatusDeducting: 'Deduction in Progress',
    tenderOfferResultFinish: 'Done',
    estimated: 'Est.',
}
